import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from "@material-ui/core";

import { NavLink, useHistory } from "react-router-dom";

import { h5Medium, h6Regular } from "../../../shared/constants";
import { useMutation } from "@apollo/client";
import { LOGOUT, GET_ACTIVE_USER } from "../../../queries/auth.queries";
import { GET_TOTAL_LINES } from "../../../queries/cart.queries";

import { ReactComponent as OrdersIcon } from "../../../assets/orders.svg";
import { ReactComponent as AddressIcon } from "../../../assets/address.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/settings.svg";
import { ReactComponent as ExitIcon } from "../../../assets/exit.svg";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  container: {},
  item: {
    ...h6Regular,
    opacity: 0.74,
  },
  activeItem: {
    ...h5Medium,
    color: "#80BB34",
  },
  icon: {
    width: 24,
    height: 24,
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  },
});

const AccountMenu = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const [logout] = useMutation(LOGOUT, {
    refetchQueries: [{ query: GET_TOTAL_LINES }, { query: GET_ACTIVE_USER }],
  });

  const menu = [
    { label: t("account.Orders"), to: "/account/orders", icon: <OrdersIcon /> },
    {
      label: t("account.Addresses"),
      to: "/account/addresses",
      icon: <AddressIcon />,
    },
    {
      label: t("account.profile"),
      to: "/account/settings",
      icon: <SettingsIcon />,
    },
  ];

  const onLogout = async () => {
    await logout();
    localStorage.removeItem("isAddressSet");
    history.push("/");
    window.location.reload();
  };

  return (
    <div className={classes.container}>
      <List>
        {menu.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={classes.link}
            activeClassName={classes.activeItem}
          >
            <ListItem button>
              <ListItemIcon className={classes.icon}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} className={classes.item} />
            </ListItem>
          </NavLink>
        ))}
      </List>

      {/* Logout */}
      <List>
        <ListItem button onClick={onLogout}>
          <ListItemIcon className={classes.icon}>
            <ExitIcon />
          </ListItemIcon>
          <ListItemText primary={t("menu.Sign Out")} className={classes.item} />
        </ListItem>
      </List>
    </div>
  );
};

export default AccountMenu;
